import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient, queryClient } from "../../clients";

import type { IMemberPapers } from "@api/members/papers/routeType";
import { useGetAllMemberPapers } from "@api/members/papers/getAll";
import { useGetMemberPaper } from "@api/members/papers/get";

const { getPath } = getApi("members.papers.post");

type IExtractedRouteType = IMemberPapers["paperSingleCreate"];

export type IPostMemberPaper = IPickMutation<IExtractedRouteType>;

const postMemberPaper: MutationFunction<
  IPostMemberPaper["response"],
  IPostMemberPaper["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberPaper = createMutation({
  mutationFn: postMemberPaper,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberPapers.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberPaper.getKey({ memberId }),
    });
  },
});
